import environment from '@app/environments/environment';
import * as models from '@app/models/index';
import axios, { CancelToken } from 'axios';
import { Injectable } from 'injection-js';

@Injectable()
export class CarrierAccountService {
	private baseUrl = environment.apiGateway.apiUrl;
	private carrierAccountApiUrl = '';

	constructor() {
		this.carrierAccountApiUrl = this.baseUrl + 'CarrierAccount/';
	}

	/**
	 * Get CarrierAccount
	 * @param appId
	 * @param cancelToken
	 */
	public async GetCarrierAccounts(
		appId: string,
		cancelToken: CancelToken,
		fetchAll?: boolean,
		skipAppStatusFilter?: boolean
	): Promise<models.ICarrierAccounts[]> {
		try {
			const url = this.baseUrl + 'CarrierAccount';
			const res = await axios.get<models.ICarrierAccounts[]>(url, {
				cancelToken,
				params: {
					appId,
					fetchAll,
					skipAppStatusFilter,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

    /**
    * @param accountId 
    * @param cancelToken  
    */
    public async getCarrierSpecialServices(
        accountId: string,
        cancelToken?: CancelToken
    ): Promise<models.IAccountDisableSpecialService[]> {
        const url = this.baseUrl + 'CarrierAccount/' + 'SpecialService';
        const res = await axios.get<models.IAccountDisableSpecialService[]>(url, {
            params: {
                accountId,
            },
            cancelToken,
        });
        return res.data;
    }

	/**
	 * Create Carrier Account
	 * @param data
	 * @param appId
	 * @param cancelToken
	 */
	public async CreateCarrierAccount(
		data: any,
		appId: string,
		cancelToken?: CancelToken
	): Promise<models.ICarrierAccounts> {
		try {
			const url = this.carrierAccountApiUrl;
			const res = await axios.post<models.ICarrierAccounts>(url, data, {
				cancelToken,
				params: {
					appId,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Update Carrier Account
	 * @param data
	 * @param appId
	 * @param cancelToken
	 */
	public async EditCarrierAccount(
		data: models.ICarrierAccounts,
		appId: string,
		cancelToken?: CancelToken
	): Promise<models.ICarrierAccounts> {
		try {
			const url = this.carrierAccountApiUrl;
			const res = await axios.put<models.ICarrierAccounts>(url, data, {
				cancelToken,
				params: {
					appId,
				},
			});
			return res.data;
		} catch (error) {
			throw error;
		}
	}

	/**
	 * Delete CarrierAccount
	 * @param appId
	 * @param carrierId
	 * @param cancelToken
	 */
	public async DeleteCarrierAccount(appId: string, carrierId: string, cancelToken?: CancelToken): Promise<boolean> {
		try {
			const url = this.carrierAccountApiUrl + `${carrierId}`;
			const res = await axios.delete(url, {
				cancelToken,
				params: {
					appId,
				},
			});
			return res.data;
		} catch (err) {
			throw err;
		}
	}
}



// WEBPACK FOOTER //
// ./src/services/carrier-account.service.ts